/**
 * @description
 * 1. 档位渲染
 * 2. 档位拉起支付
 * 3. 自定义档位输入框
 */

import { computed, ref, toRefs } from "@vue/composition-api"
import { createNamespacedHelpers } from "vuex-composition-helpers"
import * as config from "../../config"
import cookies from "../../../../utils/cookies"
import MUTATION_TYPES from "../../store/apple-gift-card/mutation-types"
import { AppleGiftCardActions } from "../../store/apple-gift-card/actions"
import { AppleGiftCardGetters } from "../../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../../store/apple-gift-card/mutations"
import { AppleGiftCardState, UsingLocation } from "../../store/apple-gift-card/state"

const { useActions, useGetters, useMutations, useState } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")

interface RechargeProps extends Record<string, unknown> {
  selectedPayNum: number
  startPay: (num: number, groupid?: string) => void
  showAppleAuth: () => void
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (props: RechargeProps, emit: (event: string, ...args: any[]) => void) => {
  const { startPay, showAppleAuth } = props
  const { selectedPayNum } = toRefs(props)
  const {
    userTypeActivity,
    productItem,
    selectedCoupon,
    configInfo,
    userDrmDiscountQualified,
    buyNum,
    agreeChecked,
    isLoading,
    notSign,
    usingLocation
  } = useState([
    "productItem",
    "selectedCoupon",
    "configInfo",
    "userDrmDiscountQualified",
    "buyNum",
    "agreeChecked",
    "isLoading",
    "notSign",
    "usingLocation",
    "userTypeActivity"
  ])
  const { fullDiscountValid, loginState } = useGetters(["banners", "fullDiscountValid", "loginState"])
  const { reportUserAction, setToastMsg } = useActions(["reportUserAction", "setToastMsg"])
  const mutations = useMutations([MUTATION_TYPES.SET_BUY_NUM, MUTATION_TYPES.SET_HIDE_WARN])

  const buyInputTimer = ref<number | null>(null)
  const isBuyNumValid = ref(true)
  const displayPopupBox = ref(false)
  const isAppleGiftCardLocation = computed(() => usingLocation.value === UsingLocation.APPLE_GIFT_CARD)

  const customBuy = async (num: string) => {
    displayPopupBox.value = false
    if (fullDiscountValid.value && userDrmDiscountQualified.value) {
      // 存在全场折扣，且用户有资格
      void startPay(Number(num), configInfo.value?.activityInfo?.group_id)
    } else if (userTypeActivity?.value) {
      // 存在用户类型活动
      void startPay(Number(num), userTypeActivity.value.group_id)
    } else {
      void startPay(Number(num))
    }
  }
  const closePayError = () => emit("update:payErrorMsg", "")
  const handleDrmLimitResult = async () => {
    emit("update:drmLimitMsg", "")
    await startPay(selectedPayNum.value)
    cookies.del("apple_card_pay_num")
  }
  const changeBuyNum = (e: any) => {
    if (buyInputTimer.value !== null) {
      clearTimeout(buyInputTimer.value)
      buyInputTimer.value = null
    }
    const value = e?.target?.value?.replace(/^0/, "").replace(/\D*/gi, "")
    mutations[MUTATION_TYPES.SET_BUY_NUM](value)
    isBuyNumValid.value = value === "" ? true : value <= 1000 && value >= 6
    buyInputTimer.value = window.setTimeout(() => {
      reportUserAction({
        iformat: config.REPORT.CLICK.CUSTOM_INPUT_NUM
      })
    }, 1500)
  }

  const showPopupBox = async () => {
    if (!isAppleGiftCardLocation.value) {
      reportUserAction({
        iformat: config.REPORT.CLICK[usingLocation.value].INPUT
      })
    }
    if (!agreeChecked.value) {
      mutations[MUTATION_TYPES.SET_HIDE_WARN](false)
      setToastMsg({ toastMsg: "请先勾选服务协议" })
      return
    }
    if (notSign.value) {
      try {
        showAppleAuth()
      } catch (e) {
        reportUserAction({
          iformat: config.REPORT.PAGEVIEW.GET_WECHAT_REALNAME_INFO_ERROR,
          resultInfo: e
        })
      }
      return
    }

    displayPopupBox.value = true
  }
  const hidePopupBox = () => {
    displayPopupBox.value = false
  }
  const handleCustomBuy = () => {
    const num = Number(buyNum.value)
    if (num < 6 || num > 1000) {
      setToastMsg({ toastMsg: "请输入6-1000的整数" })
      return
    }
    customBuy(buyNum.value)
  }

  const displayRechargeBtn = computed(() => {
    return loginState.value.openid && loginState.value.openkey && productItem.value?.length > 0
  })

  const RechargeBtnRowsCount = computed(() => Math.ceil((productItem.value.length + 1) / 3))
  const RechargeBtnColumns = (n: number) => productItem.value.slice(3 * (n - 1), 3 * n)

  return {
    productItem,
    selectedCoupon,
    buyNum,
    isBuyNumValid,
    displayPopupBox,
    isAppleGiftCardLocation,
    isLoading,
    loginState,
    displayRechargeBtn,
    RechargeBtnRowsCount,
    RechargeBtnColumns,
    closePayError,
    handleDrmLimitResult,
    customBuy,
    changeBuyNum,
    showPopupBox,
    hidePopupBox,
    handleCustomBuy
  }
}
